/**
 * Created by 孙猛 on 2020/10/29.
 * 订单接口集合
 */
import { post, post2, postSettle } from 'utils/post';
/*
 订单列表 2020/10/28.
 status参数说明
 -1 全部订单 0-等待付款 2-已付款待确认 5-待收货 7-已成功 8-已取消
 2020/10/28.
 */
export function getOrderList(data) {
  return post2('/api/order/list', data)
}

// 订单详情 2020/10/29
export function getOrderDetail(data) {
  return post2('/api/order/getOrderItem', data)
}
// 订单详情 2018年3月1日22:30:15
export function getOrderDetailBySn(data) {
  return post2('/api/returnOrder/getItem', data)
}
// 订单确认收货 2020/10/28
export function rogConfirm(data) {
  return post2('/api/order/confirmReceipt', data)
}
// 订单取消时提示 2018年5月4日15:04:07
export function preCancelOrder(data) {
  return post2('/api/order/beforeCancelOrder', data)
}
// 取消订单 2018年2月8日13:44:07
export function orderCancel(data) {
  return post2('/api/order/cancelOrder', data)
}

// 订单延迟收货 2018年2月8日13:44:07
export function rogDelay(data) {
  return post2('/api/order/receivingGoodsDelay', data)
}
// 立即付款 2018年2月28日21:37:15
export function payOrder(data) {
  return post('/api/shop/pay', data)
}

// 获取订单金额
export function getOrderAmount(data) {
  return post2('/api/order/getOrderPayInfo', data)
}

//获取物流列表接口
export function getLogisticsList() {
  return post2('/api/logistics/list');
}
//填写物流信息提交接口
export function sentLogistics(data) {
  return post2('/api/returnOrder/updateLogistics', data)
}
//根据订单物流参数获取物流详情
export function getLogistics(data) {
  return post2('/api/logistics/getTrackInfo', data);
}
//确认支付订单
export function checkOrderPay(data) {
  return post2('/api/order/checkOrderAlreadyPay', data)
}
//支付宝支付订单
// export function aliPayOrder(data) {
//   return post('/api/order/alipayOrderSign',data)
// }
//获取支付宝参数，微信参数 接口
// export function pcZfbPayment(data) {
//   return post2('/api/shop/pcZfbPayment', data)
// }
//获取支付方式
export function getPayType(data) {
  return post2('/api/pay/paymentStatus/get', data)
}
//订单支付宝,微信,积分，返回付款码接口 共用接口,
export function doPay(data) {
  return post2('/api/pay/gdPay', data)
}
//订单微信返回付款码接口
// export function wxPay(data) {
//   return post2('/api/v2/pay/wxpay', data)
// }
//商务中心验证
// export function checkBusinessCenter (id,data) {
//   return post2('/api/member/checkBusinessCenter',data)
// }
// export function checkBusinessCenter(data) {
//   return post('/api/order/checkBusinessCentre', data)
// }
//商务中心验证--重构接口
export function checkBusinessCenter(data) {
  return post2('/api/client/user/getBusinessCenter', data)
}

// 获取验证码
export function getSettleCode(data) {
  return post2('/api/client/common/validate/getCode', data)
}

// 获取验证码 未登录
export function getNoSettleCode(data) {
  return post2('/api/client/common/sendMessage', data)
}

// 注册用户
export function userNewRegister(data) {
  return postSettle('/api/client/common/userRegister', data)
}



//获取订单各状态数量
export function getOrderCount() {
  return post('/api/order/count')
}




// WEBPACK FOOTER //
// ./src/api/order.js